import React from 'react'

import { TIME_LABEL_WIDTH } from '../../constants'

import styles from './index.module.css'

// 00:00, 00:30, 01:00, ..., 23:30, 24:00（30分間隔 = 49個）
const labels = Array.from({ length: 24 * 2 + 1 }, (_, i) => {
  const minutes = i * 30
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return {
    minutes,
    label: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`,
  }
})

type Props = {
  pxPerMinute: number
}

export const TimeLabels: React.FC<Props> = React.memo(({ pxPerMinute }) => (
  <div className={styles.column} style={{ width: TIME_LABEL_WIDTH, minWidth: TIME_LABEL_WIDTH }}>
    {labels.map(({ minutes, label }) => (
      <div className={styles.item} key={minutes} style={{ top: minutes * pxPerMinute }}>
        {label}
      </div>
    ))}
  </div>
))
